import { PropsWithChildren, ReactNode } from 'react';
import {
    UserStatusCongratulationsBenefitsCardBadgeContainerInnerStyled,
    UserStatusCongratulationsBenefitsCardBadgeContainerOuterStyled,
    UserStatusCongratulationsBenefitsCardStyled,
} from './styled/UserStatusCongratulationsBenefitsCardStyled';

type IUserStatusCongratulationsBenefitsBadgeProps = PropsWithChildren<{
    badgeComponent: ReactNode,
}>

function UserStatusCongratulationsBenefitsCard(props: IUserStatusCongratulationsBenefitsBadgeProps) {
    const { badgeComponent, children } = props;

    return <UserStatusCongratulationsBenefitsCardStyled>
        <UserStatusCongratulationsBenefitsCardBadgeContainerOuterStyled>
            <UserStatusCongratulationsBenefitsCardBadgeContainerInnerStyled>
                {badgeComponent}
            </UserStatusCongratulationsBenefitsCardBadgeContainerInnerStyled>
        </UserStatusCongratulationsBenefitsCardBadgeContainerOuterStyled>
        {children}
    </UserStatusCongratulationsBenefitsCardStyled>
}

export default UserStatusCongratulationsBenefitsCard;
